/* DOMEMARE motion layer: scroll reveal mit IntersectionObserver.
   Inhalte bleiben ohne JS und für Crawler vollständig sichtbar.
   Zusätzlich: Sicherheitsnetz gegen doppeltes Product-Schema (Theme-Standard neben snippets/json-ld-product). */
(function () {
  /* Doppeltes Product-JSON-LD entfernen: unser Schema trägt eine @id mit "#product". */
  try {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    var ours = false;
    scripts.forEach(function (s) { if (s.textContent.indexOf('#product') > -1 && s.textContent.indexOf('"@type": "Product"') > -1) ours = true; });
    if (ours) {
      scripts.forEach(function (s) {
        var t = s.textContent;
        if (t.indexOf('"@type":"Product"') > -1 && t.indexOf('#product') === -1) s.parentNode.removeChild(s);
      });
    }
  } catch (e) {}

  var html = document.documentElement;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  html.classList.add('dm-js');

  function tag(selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (!el.classList.contains('dm-reveal')) el.classList.add('dm-reveal');
    });
  }

  function init() {
    tag('.card, .product-card, .section-wrapper__header, .dm-callout, .dm-facts, .dm-procon, .dm-embed, .dm-acard');
    document.querySelectorAll('.grid, .dm-agrid').forEach(function (g) { g.classList.add('dm-stagger'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    document.querySelectorAll('.dm-reveal').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { el.classList.add('is-in'); } else { io.observe(el); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
